import dayjs from 'dayjs';

import { TaskStatus } from './types';

const STATUS_LABEL: Record<string, string> = {
  not_started: 'To do',
  in_progress: 'In progress',
  submitted: 'Submitted',
  approved: 'Approved',
  closed: 'Closed',
};

export const statusLabel = (status: TaskStatus): string => STATUS_LABEL[status] ?? status;

/** Colour for a task state. Open work stays warm; finished work recedes. */
export const statusTone = (status: TaskStatus): { bg: string; color: string } => {
  if (status === 'not_started') return { bg: '#FFF4E5', color: '#8A4B08' };
  if (status === 'in_progress') return { bg: '#E8F1FF', color: '#1D4E89' };
  if (status === 'submitted' || status === 'approved') return { bg: '#E7F6EE', color: '#1B7A43' };
  return { bg: '#F2F3F5', color: '#5B6472' };
};

/** A calendar date. Empty when the value is missing, so callers can choose the fallback. */
export const formatWhen = (value: string | null): string => {
  if (!value) return '';
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('D MMM YYYY') : value;
};

/** Due copy. A task with no date is due now, rather than announcing the absence. */
export const formatDue = (value: string | null): string => formatWhen(value) || 'now';

/** Review totals. Two decimal places at most, with grouping, so a raw float does not land on the page. */
export const formatFigure = (value: number): string => {
  if (!Number.isFinite(value)) return '';
  const rounded = Math.round((value + Number.EPSILON) * 100) / 100;
  return rounded.toLocaleString('en-GB', { maximumFractionDigits: 2 });
};
